define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/config",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,Controller,config,locale,MessageDialog,xml) {

	return declare(Controller, {
		process: function() {
			var self = this;

			// see if we should warn the user about data that will be ignored due to size chart settings tied to a Shape on "Merge"
			if (this.m_formData.getField("SizeChartPasteOperation").getValue() == 0) { // 0 = "Merge"
				var sizeChart = this.m_cache.getNode(this.getParent().__Parent__);
				if (config.getNodeSetting(sizeChart, "LockShapeDimensionValues") || config.getNodeSetting(sizeChart, "LockShapeTolerance")) {
					this.confirmAction({
						message: locale.resource("SizeChartPasteWarning"),
						buttons: [MessageDialog.BUTTON_OK],
						onResponse: function() {
							Controller.prototype.process.call(self);
						}
					});
				} else {
					this.inherited(arguments);
				}
			} else {
				this.inherited(arguments);
			}
		},
		
		toWriterRequest: function() {
			// summary: add paste-data param to server op
			var call = this.inherited(arguments);
			call.addParameter("Data", xml.ATTR_STRING, this.getFormData().getFieldInitialValue("Data"));
			return call;
		}
	});
});